/**
 * StructuredData — renders a JSON-LD <script> tag so Google can build rich
 * results (event snippets, product cards, sitelinks) from your pages.
 * Usage: <StructuredData data={{ "@context": "https://schema.org", ... }} />
 */
export default function StructuredData({ data }) {
    if (!data) return null;
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
}
